import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/skapa-annons',
      name: 'item-create',
      component: () => import('./views/item/Create.vue')
    },
    {
      path: '/annons/:slug/:id',
      name: 'item-view',
      component: () => import('./views/item/View.vue')
    },
    {
      path: '/gluo/om-gluo',
      name: 'site-about',
      component: () => import('./views/site/About.vue')
    },
    {
      path: '/gluo/kontakta-oss',
      name: 'site-contact',
      component: () => import('./views/site/Contact.vue')
    },
    {
      path: '/gluo/fragor-och-svar',
      name: 'site-faq',
      component: () => import('./views/site/Faq.vue')
    },
    {
      path: '/villkor/kakor',
      name: 'site-cookies',
      component: () => import('./views/site/Cookies.vue')
    },
    {
      path: '/sakerhet/anmal-olampliga-annonser',
      name: 'site-item-report',
      component: () => import('./views/site/ItemReport.vue')
    },
    {
      path: '/actions/activate/:token',
      name: 'item-activate',
      component: () => import('./views/item/Activate.vue')
    },
    {
      path: '/actions/manage/:token',
      name: 'item-manage',
      component: () => import('./views/item/Manage.vue')
    },
    {
      path: '*',
      name: 'page-not-found',
      component: () => import('./views/PageNotFound.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.name !== 'home') {
      return { x: 0, y: 0 }
    }
  }
})
